import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthConfigService, GlobalMessageService, RoutingService } from '@spartacus/core';
import { ForgotPasswordComponentService } from '@spartacus/user/profile/components';
import { Subscription } from 'rxjs';
import { CustomValidators } from '../../../../../custom/shared/utils/validators/custom-validators';
import { CustomUserPasswordService } from '../../../core/facades/custom-user-password.service';

@Injectable()
export class CustomForgotPasswordComponentService extends ForgotPasswordComponentService {
  protected subscriptions: Subscription = new Subscription();

  constructor(
    protected userPasswordService: CustomUserPasswordService,
    protected routingService: RoutingService,
    protected authConfigService: AuthConfigService,
    protected globalMessage: GlobalMessageService
  ) {
    super(userPasswordService, routingService, authConfigService, globalMessage);
  }

  override form: UntypedFormGroup = new UntypedFormGroup({
    userEmail: new UntypedFormControl('', [Validators.required, CustomValidators.emailValidator])
  });
}
